'use strict';

var EventEmitter = require('events').EventEmitter
  , inherits = require('inherits')
  ;

function XHRFake(/* method, url, payload, opts */) {
  var self = this;
  EventEmitter.call(this);

  this.to = setTimeout(function() {
    self.emit('finish', 200, '{}');
  }, XHRFake.timeout);
}

inherits(XHRFake, EventEmitter);

XHRFake.prototype.close = function() {
  clearTimeout(this.to);
};

XHRFake.timeout = 2000;

module.exports = XHRFake;



//////////////////
// WEBPACK FOOTER
// C:/Users/Pablo/source/repos/prote/angular/~/sockjs-client/lib/transport/sender/xhr-fake.js
// module id = ../../../../sockjs-client/lib/transport/sender/xhr-fake.js
// module chunks = 19